// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_SEQ","cls2":"Unibrow-cls2_Lom Unibrow-cls1_SEQ"};